export enum IntercomPageContext {
	UpgradeFeatureSpecific = 'Upgrade_Feature_Specific',
	UpgradePlan = 'Upgrade_Plan_Page',
	PlanCancellationModal = 'Premium_Cancellation',
	LoyalyExistenceQuestion = 'Existing_Loyalty',
	PaymentFailure = 'Payment_Failure',
	PremiumPlanPriceChange = 'Premium_Plan_Price_Change',
	ProfileHelp = 'Profile_Help',
	GeneralDashboard = 'General_Dashboard',
}
